import { action, observable } from "mobx";
import { api } from "../../api";
import { ITipi } from "../../model";
import { toast } from "react-toastify";

export class _TipiStore {
  obs = observable({
    tipis: [] as ITipi[],
    total: 0 as number,
  })


  constructor() {
  }

  @action
  async load(page: number): Promise<void> {
    try {
      let resp = await api.get(`/api/tipi-index/${page}`);

      this.obs.tipis = [];
      this.obs.total = resp.data.total;
      this.obs.tipis = resp.data.itens
    } catch (ex) {
      toast.error("Erro ao carregar Tipi, tente novamente mais tarde.", {});
    }
  }

  async busca(filter: string, paged) {
    try {
      let params = {
        filter: filter,
        page: paged,
        limit: 15
      }
      let resp = await api.post(`/api/filtra-tipi`, params);

      this.obs.tipis = [];
      this.obs.total = resp.data.total;
      this.obs.tipis = resp.data.itens
    } catch (ex) {
      toast.error("Erro ao filtrar Tipi, tente novamente mais tarde.", {});
    }
  }
}

export const TipiStore = new _TipiStore();
